import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BadgeCheckIcon, XIcon } from "lucide-react";
import { recentBuyers, images } from "../data/content";
type Buyer = {
  name: string;
  country: string;
  minutes: number;
};
function pickBuyer(prev?: Buyer): Buyer {
  let b = recentBuyers[Math.floor(Math.random() * recentBuyers.length)];
  while (prev && b.name === prev.name) {
    b = recentBuyers[Math.floor(Math.random() * recentBuyers.length)];
  }
  return {
    ...b,
    minutes: Math.floor(Math.random() * 12) + 1
  };
}
export function PurchasePopup() {
  const [buyer, setBuyer] = useState<Buyer | null>(null);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const show = () => {
      setBuyer(prev => pickBuyer(prev ?? undefined));
      hideTimer = window.setTimeout(() => setBuyer(null), 5000);
    };
    const first = window.setTimeout(show, 6000);
    const loop = window.setInterval(show, 15000);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(loop);
    };
  }, [dismissed]);
  return <div className="pointer-events-none fixed bottom-24 left-3 right-3 z-50 sm:right-auto sm:w-[360px]" aria-live="polite" data-id="element-235" data-mp="1fwbwruqlgypu">
      <AnimatePresence data-id="element-236" data-mp="1axqyi0uwkp41">
        {buyer && !dismissed && <motion.div key={buyer.name + buyer.minutes} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex items-center gap-3 rounded-2xl border border-ink/10 bg-white p-3 pr-9 shadow-[0_16px_40px_-12px_rgba(11,26,46,0.45)]" data-id="element-237" data-mp="n6v7v726nzyd">
            <img src={images.mainMockup} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-cream object-cover" data-id="element-238" data-mp="23lda9weab01z" />
            <div className="min-w-0" data-id="element-239" data-mp="2aothw6inzjez">
              <p className="text-sm leading-snug text-ink" data-id="element-240" data-mp="2anrwp97xpgjj">
                <strong data-id="element-241" data-mp="2fnec9pb8j8vi">{buyer.name}</strong> from <strong data-id="element-242" data-mp="2fmcwx8n6s07z">{buyer.country}</strong>
              </p>
              <p className="text-sm leading-snug text-ink/75" data-id="element-243" data-mp="2kn0p3xn5in3s">just purchased The Sexual Control Protocol™</p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold text-success" data-id="element-244" data-mp="2pmdh0wsvqkd8">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-245" data-mp="1rylju2ttnj5n" />
                {buyer.minutes} min ago · Verified
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="absolute right-2 top-2 rounded-full p-1 text-ink/40 hover:bg-cream hover:text-ink" data-id="element-246" data-mp="1wutvh68t8u82">
              <XIcon className="h-4 w-4" data-id="element-247" data-mp="196sow2v6znva" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}